import React from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { Input } from './Input';
import * as TYPES from './types';

export function formFactory<T>(
  form: string,
  validate?: (formValues: {}) => {},
) {
  class FormComponent extends React.Component<
    TYPES.FormProps & InjectedFormProps<T, TYPES.FormProps>
  > {
    renderActions() {
      const { actionButtons } = this.props;
      if (actionButtons) {
        return actionButtons;
      }

      return (
        <button type='submit' className='ui button primary blue'>
          Enviar
        </button>
      );
    }

    renderFields() {
      return this.props.fieldList.map(
        ({ component = Input, readOnly, name, label, type }) => {
          return (
            <Field
              component={component}
              readOnly={readOnly}
              name={name}
              label={label}
              type={type}
              key={name}
            />
          );
        },
      );
    }

    render() {
      const { handleSubmit, submitHandler } = this.props;
      return (
        <form className='ui form error' onSubmit={handleSubmit(submitHandler)}>
          {this.renderFields()}
          {this.renderActions()}
        </form>
      );
    }
  }

  return reduxForm<T, TYPES.FormProps>({
    form,
    validate,
    enableReinitialize: true,
  })(FormComponent);
}
